module.exports = __webpack_public_path__ + "img/geotextilEspecificacoes.e6003615.png";